<!-- @format -->

@if (data$ | async) {
  <div class="module-content-application">
    <div class="row">
      <div class="offset-md-1 col-md-10 offset-lg-2 col-lg-8">
        <div class="row">
          <div class="col-12">
            @if (isApproved || isPendingApproval) {
              <div class="revoke-cancel-button-holder float-end button-row">
                @if (isPendingApproval) {
                  <sis-button [size]="'lg'" [variant]="'primary'" (clicked)="cancel()">
                    {{ "SHOW_MODULE_CONTENT_APPROVAL_MODAL." + moduleContentWorkflow.type + ".CANCEL_REQUEST" | translate }}
                  </sis-button>
                }
                @if (isApproved) {
                  <sis-button [size]="'lg'" [variant]="'primary'" (clicked)="revoke()">
                    {{ "SHOW_MODULE_CONTENT_APPROVAL_MODAL." + moduleContentWorkflow.type + ".REVOKE_APPROVAL" | translate }}
                  </sis-button>
                }
              </div>
            }
            @if (isApplicationCancelledByStaff) {
              <sis-contextual-notification [variant]="'warning'"
                >{{ "PROFILE.APPLICATIONS.APPLICATION_CANCELLED_BY_STAFF" | translate }}
                <sis-button [link]="true" (clicked)="showWorkflowApplicationCancelledInfoModal()">
                  {{ "PROFILE.APPLICATIONS.APPLICATION_CANCELLED_SHOW_INFORMATION" | translate }}
                </sis-button>
              </sis-contextual-notification>
            }
            @if (isApplicationAcceptanceRevokedByStaff) {
              <sis-contextual-notification [variant]="'warning'"
                >{{ "PROFILE.APPLICATIONS.APPLICATION_ACCEPTANCE_REVOKED_BY_STAFF" | translate }}
                <sis-button [link]="true" (clicked)="showWorkflowApplicationAcceptanceRevokedInfoModal()">
                  {{ "PROFILE.APPLICATIONS.APPLICATION_CANCELLED_SHOW_INFORMATION" | translate }}
                </sis-button>
              </sis-contextual-notification>
            }
            @if (isCreatedByStaff) {
              <sis-contextual-notification [variant]="'light'">{{
                "PROFILE.APPLICATIONS.APPLICATION_CREATED_BY_STAFF" | translate
              }}</sis-contextual-notification>
            }
            @if (!planExists) {
              <sis-contextual-notification [variant]="'warning'">{{
                "SHOW_MODULE_CONTENT_APPROVAL_MODAL.PLAN_DELETED" | translate: { planName: plan.name }
              }}</sis-contextual-notification>
            }
            @if (planExists && !isInPlan) {
              <sis-contextual-notification [variant]="'warning'">{{
                "SHOW_MODULE_CONTENT_APPROVAL_MODAL.REMOVED_FROM_PLAN" | translate
              }}</sis-contextual-notification>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="clearfix"></div>
            @if (!moduleContentWorkflow.decision) {
              <div>
                <h2>{{ "STUDENT_APPLICATIONS.APPLICATION_INFO" | translate }}</h2>
                <app-module-content-workflow-summary
                  [moduleContentWorkflow]="moduleContentWorkflow"
                  [moduleContentWorkflowStructureData]="moduleContentWorkflowStructureData"
                  (openPlan)="openPlan()">
                </app-module-content-workflow-summary>
              </div>
            }
            @if (moduleContentWorkflow.decision) {
              <div>
                <sis-expandable [title]="'STUDENT_APPLICATIONS.APPLICATION_INFO' | translate" [closed]="false">
                  <ng-template sisExpandableContent>
                    <app-module-content-workflow-summary
                      [moduleContentWorkflow]="moduleContentWorkflow"
                      [moduleContentWorkflowStructureData]="moduleContentWorkflowStructureData"
                      (openPlan)="openPlan()">
                    </app-module-content-workflow-summary>
                  </ng-template>
                </sis-expandable>
                <!-- We do not want to display decisions with the REVOKED state, because they have been made by the student.
                From the staff's perspective, it is not considered a decision, even though it is decision in our data model. -->
                @if (moduleContentWorkflow.state !== "REVOKED") {
                  <sis-expandable [title]="'STUDENT_APPLICATIONS.DECISION_INFO' | translate" [closed]="false">
                    <ng-template sisExpandableContent>
                      <sis-module-content-workflow-decision
                        [moduleContentWorkflowDecision]="$any(moduleContentWorkflow.decision)"
                        [moduleContentWorkflowType]="moduleContentWorkflow.type">
                      </sis-module-content-workflow-decision>
                    </ng-template>
                  </sis-expandable>
                }
                @if (acceptedHistoryDecision) {
                  <sis-expandable [title]="'STUDENT_APPLICATIONS.LATEST_ACCEPTED_DECISION' | translate" [closed]="false">
                    <ng-template sisExpandableContent>
                      <sis-module-content-workflow-decision
                        [moduleContentWorkflowDecision]="acceptedHistoryDecision"
                        [moduleContentWorkflowType]="moduleContentWorkflow.type">
                      </sis-module-content-workflow-decision>
                    </ng-template>
                  </sis-expandable>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
